module.exports = __webpack_public_path__ + "static/img/IMG_20151230_113203.34877c2b.jpg";